import { ConditionEvaluator } from "./conditionEvaluator";
import { ControlChildI } from "../typings/routesTypes";

// Selected values of a filter field as a list (categoryLv1Id -> categoryLv1Ids of the subcategory filter)
const selectedValues = (filterValues: any, field: string): string[] => {
  const values = filterValues ? filterValues[field + "s"] || filterValues[field] : undefined;
  if (!values) return [];
  return Array.isArray(values) ? values : [values];
};

/**
 * Filter groups to only include controls whose conditions are met.
 * Controls without a condition are always included.
 * A control with `subcategoryField` (make picker narrowed to subcategories) gets the selected
 * subcategory ids as `subcategoryIds`.
 */
export const filterGroupsByCondition = (groups: any[], filterValues: any): any[] => {
  if (!groups || groups.length === 0) return groups;
  return groups.map(group => ({
    ...group,
    controls: (group.controls || [])
      .filter(control => {
        if (!control.condition) return true;
        return ConditionEvaluator.evaluateCondition(control.condition, filterValues || {});
      })
      .map(control =>
        control.subcategoryField
          ? { ...control, subcategoryIds: selectedValues(filterValues, control.subcategoryField) }
          : control
      )
  }));
};

/**
 * Get field names of controls whose conditions are NOT met (hidden controls).
 * Used to exclude hidden field values from search submission.
 */
export const getHiddenFieldNames = (groups: any[], filterValues: any): string[] => {
  const hiddenFields: string[] = [];
  if (!groups) return hiddenFields;

  const collectChildFields = (child: ControlChildI) => {
    if (child.field) hiddenFields.push(child.field);
    if (child.child) collectChildFields(child.child);
  };

  groups.forEach(group => {
    (group.controls || []).forEach(control => {
      if (
        control.condition &&
        !ConditionEvaluator.evaluateCondition(control.condition, filterValues || {})
      ) {
        if (control.field) hiddenFields.push(control.field);
        if (control.fromField) hiddenFields.push(control.fromField);
        if (control.toField) hiddenFields.push(control.toField);
        if (control.child) collectChildFields(control.child);
        if (control.options) {
          control.options.forEach((o: any) => {
            if (o.field) hiddenFields.push(o.field);
          });
        }
      }
    });
  });

  return hiddenFields;
};

/**
 * Remove hidden field values from data object.
 */
export const removeHiddenFields = (data: any, hiddenFields: string[]): any => {
  if (!data || hiddenFields.length === 0) return data;
  const cleaned = { ...data };
  hiddenFields.forEach(f => delete cleaned[f]);
  return cleaned;
};



// WEBPACK FOOTER //
// ./src/utils/searchFilterConditions.ts